import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CreateOpportunitySourceRequest extends BaseUpdateRequest {
    name = '';
}
